import React from 'react';
import SoundButton from './SoundButton';
import SoundDivider from './SoundDivider';
import { Text, View } from 'react-native';
import { getCardSounds } from './HelperFunctions'

const MinionSounds = (props) => {

  const card = props.card
  const cardsMissingSounds = ['UNG_065t','DAL_357t','BGS_046t', 'BAR_919t','SW_028t6']
  
  let cardSounds = getCardSounds(card)
    
  return (
      <>
        <View style={{justifyContent: 'space-around'}}>

          {/*Cards with no sounds render differently.*/}
          {(cardsMissingSounds.includes(card.id) ? <Text>{"This card has no sounds!"}</Text> : 
              <>
                {/* Build a distinct array of row numbers and render a set of buttons for each. */}
                {[...new Set(cardSounds.map(sound => sound.row))].sort().map(row => (
                    <View style={{flexDirection: 'row', alignItems: 'center', marginBottom: 8, justifyContent: 'center'}}>
                      {/* Filter mapped sounds for only those that match the row. */}
                      {cardSounds.filter(sound => sound.row == row).map(sound => (
                        <SoundButton title={sound.name} sound={sound.audio}/>
                      ))} 
                    </View>
                  ))}
              </>
          )}
        </View>
        <SoundDivider/>
      </>
  )
}

export default MinionSounds